import { render, staticRenderFns } from "./editProfile.vue?vue&type=template&id=7b1c2f25&scoped=true"
import script from "./editProfile.vue?vue&type=script&lang=js"
export * from "./editProfile.vue?vue&type=script&lang=js"
import style0 from "./editProfile.vue?vue&type=style&index=0&id=7b1c2f25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1c2f25",
  null
  
)

export default component.exports